const ZtrikeAddress = '0x53Bb2A1EE8E771b777401c0dDC05854fda44b42D';
const NFTAddress = '0xF40e6d0092366Ae2f375552fde083e9C05947FE7';
const MarketplaceAddress = '0x49BcF21B5a15bc46846A3C4A5E415BEcE5169B64';

export {ZtrikeAddress,
        NFTAddress,
        MarketplaceAddress
};